import {rqCreateRequest, rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {
  RQ_ACTIVE_DOCTORS_API,
  RQ_ACTIVE_DOCTORS_DETAILS_API,
  RQ_ATTRITION_API,
  RQ_ATTRITION_DETAILS_LINK_API,
  RQ_BRAND_IN_MANAGER_ASSIST_API,
  RQ_BRAND_PERFORMANCE_API,
  RQ_COVERAGE_DATA_API,
  RQ_COVERAGE_DETAILS_LINK_API,
  RQ_DEACTIVE_DOCTORS_API,
  RQ_DEACTIVE_DOCTORS_DETAILS_API,
  RQ_DOWNWARD_SHIFT_API,
  RQ_FIELD_DETAILS_LINK_API,
  RQ_FIELD_WORKING_API,
  RQ_GLIMADAY_DOCTOR_REPORT_API,
  RQ_GLIMADAY_REPORT_API,
  RQ_MISSED_CALL_API,
  RQ_MISSED_CALL_DETAILS_LINK_API,
  RQ_MISSED_CALL_FREQUENCY_API,
  RQ_MISSED_CALL_FREQUENCY_DETAILS_API,
  RQ_RCPA_TREND_VALUE_API, RQ_RCPA_TREND_VALUE_LINK_API,
  RQ_RCPA_VALUE_API,
  RQ_RCPA_VALUE_LINK_API,
  RQ_RXBER_NUMBER_API,
  RQ_SALES_PERFORMANCE_API,
  RQ_SAMPLE_API,
  RQ_SAMPLE_DETAIL_API,
  RQ_SHIFT_DETAILS_LINK_API,
  RQ_TOUR_PLAN_DEVIATION_API,
  RQ_TOUR_PLAN_DEVIATION_DETAILS_API,
  RQ_UPWARD_SHIFT_API,
} from '@app/reactQuery/apis/constants';
import {useQuery} from '@tanstack/react-query';

export const RQGetBrandDataInManagerAssist = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_brand_data_by_division_id', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_BRAND_IN_MANAGER_ASSIST_API,
        null,
        certificate,
        {divisionId: divisionId},
        signal,
      );
    },
    ...options,
  });
};

export const RQPostSalesPerformance = ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_SALES_PERFORMANCE_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostBrandPerformance = ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_BRAND_PERFORMANCE_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostRcpaValue = ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_RCPA_VALUE_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostRxberNumber = ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_RXBER_NUMBER_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostModalRcpaValue = ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_RCPA_VALUE_LINK_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostModalRxberValue = ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_RCPA_VALUE_LINK_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostRcpaTrendValue = ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_RCPA_TREND_VALUE_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostModalRcpaTrendValue = ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_RCPA_TREND_VALUE_LINK_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostFieldWorking = ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_FIELD_WORKING_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostCoverageData = ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_COVERAGE_DATA_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostMissedCall = ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_MISSED_CALL_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostMissedCallFrequency = ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_MISSED_CALL_FREQUENCY_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostModalMissedByFrequencyDetails = ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_MISSED_CALL_FREQUENCY_DETAILS_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostTourPlanDeviation = ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_TOUR_PLAN_DEVIATION_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostModalTourPlanDeviationDetails = ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_TOUR_PLAN_DEVIATION_DETAILS_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostAttrition = async ({locationId, certificate, signal}) => {
  return rqCreateRequest(
    RQ_ATTRITION_API,
    null,
    certificate,
    {locationId: locationId},
    signal,
    null,
  );
};

export const RQPostModalAttritionDetails =  ({locationId, yyyyMm, jobRole, certificate, signal}) => {
  return rqCreateRequest(
    RQ_ATTRITION_DETAILS_LINK_API,
    null,
    certificate,
    {locationId: locationId, yyyyMm: yyyyMm, jobRole: jobRole},
    signal,
  );
};

export const RQPostModalCoverageDetails =  ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_COVERAGE_DETAILS_LINK_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostModalFieldWorking =  ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_FIELD_DETAILS_LINK_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostModalMissedCallDetails =  ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_MISSED_CALL_DETAILS_LINK_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostUpwardShift = async ({locationId, certificate, signal}) => {
  return rqCreateRequest(
    RQ_UPWARD_SHIFT_API,
    null,
    certificate,
    {locationId: locationId},
    signal,
    null,
  );
};

export const RQPostDownwardShift = async ({locationId, certificate, signal}) => {
  return rqCreateRequest(
    RQ_DOWNWARD_SHIFT_API,
    null,
    certificate,
    {locationId: locationId},
    signal,
    null,
  );
};

export const RQPostModalShift =  ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_SHIFT_DETAILS_LINK_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostSample = async ({locationId, certificate, signal}) => {
  return rqCreateRequest(
    RQ_SAMPLE_API,
    null,
    certificate,
    {locationId: locationId},
    signal,
    null,
  );
};

export const RQPostModalSample =  ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_SAMPLE_DETAIL_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostDeactivation =  ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_DEACTIVE_DOCTORS_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostModalDeactivation =  ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_DEACTIVE_DOCTORS_DETAILS_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostActivation =  ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_ACTIVE_DOCTORS_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQPostModalActivation =  ({filters, certificate, signal}) => {
  return rqCreateRequest(
    RQ_ACTIVE_DOCTORS_DETAILS_API,
    JSON.stringify(filters),
    certificate,
    null,
    signal,
  );
};

export const RQGetGlimadayReport = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_glimaday_report', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, locationId, yearMonth} = queryKey[1];
      console.log('2', locationId, yearMonth);
      return rqCreateSearchRequest(
        RQ_GLIMADAY_REPORT_API,
        null,
        certificate,
        {locationId: locationId, yearMonth: yearMonth},
        signal,
      );
    },
    ...options,
  });
};

export const RQGetGlimadayDoctorReport = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_glimaday_doctor_report', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, locationId, yearMonth} = queryKey[1];
      console.log('2', locationId, yearMonth);
      return rqCreateSearchRequest(
        RQ_GLIMADAY_DOCTOR_REPORT_API,
        null,
        certificate,
        {locationId: locationId, yearMonth: yearMonth},
        signal,
      );
    },
    ...options,
  });
};
